import { useState } from 'react';

import type { DreamRenderElementProps } from '@/types';

import { TabsElement } from '../../shared/tabsElement/TabsElement';
import BreakdownRow from './BreakdownRow';

interface Props {
  pending: string[];
  confirmed: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations?: DreamRenderElementProps<any>['translations'];
}

const Breakdown = ({ pending, confirmed, translations }: Props) => {
  const [selectedTab, setSelectedTab] = useState<'confirmed' | 'pending'>('confirmed');

  return (
    <div className="mb-4 flex w-full items-center justify-between space-y-4">
      <div className="w-full flex flex-col gap-4">
        <TabsElement
          tabs={[
            {
              key: 'confirmed',
              label: translations?.['referrals.breakdown.confirmed'] || '',
              selected: selectedTab === 'confirmed',
              onClick: () => setSelectedTab('confirmed'),
            },
            {
              key: 'pending',
              label: translations?.['referrals.breakdown.pending'] || '',
              selected: selectedTab === 'pending',
              onClick: () => setSelectedTab('pending'),
            },
          ]}
        />

        <div className="rounded-md border border-gray-200 bg-white">
          {selectedTab === 'confirmed' &&
            (confirmed.length > 0 ? (
              <ul className="divide-y divide-gray-200">
                {confirmed.map((confirmed: string) => (
                  <BreakdownRow key={confirmed} value={confirmed} />
                ))}
              </ul>
            ) : (
              <p className="w-full p-6 text-center text-sm font-medium text-gray-600">
                {translations?.['referrals.breakdown.no_confirmed']}
              </p>
            ))}
          {selectedTab === 'pending' &&
            (pending.length > 0 ? (
              <ul className="divide-y divide-gray-200">
                {pending.map((pending: string) => (
                  <BreakdownRow key={pending} value={pending} />
                ))}
              </ul>
            ) : (
              <p className="w-full p-6 text-center text-sm font-medium text-gray-600">
                {translations?.['referrals.breakdown.no_pending']}
              </p>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Breakdown;
